/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SubmissionResultStatus = {
    Pending: 'pending',
    Accepted: 'accepted',
    UnrecognizedAnswer: 'unrecognized_answer',
    WrongAnswer: 'wrong_answer',
    RuntimeError: 'runtime_error',
    TimeLimitExceeded: 'time_limit_exceeded'
} as const;
export type SubmissionResultStatus = typeof SubmissionResultStatus[keyof typeof SubmissionResultStatus];


export function instanceOfSubmissionResultStatus(value: any): boolean {
    for (const key in SubmissionResultStatus) {
        if (Object.prototype.hasOwnProperty.call(SubmissionResultStatus, key)) {
            if (SubmissionResultStatus[key as keyof typeof SubmissionResultStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SubmissionResultStatusFromJSON(json: any): SubmissionResultStatus {
    return SubmissionResultStatusFromJSONTyped(json, false);
}

export function SubmissionResultStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionResultStatus {
    return json as SubmissionResultStatus;
}

export function SubmissionResultStatusToJSON(value?: SubmissionResultStatus | null): any {
    return value as any;
}

export function SubmissionResultStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): SubmissionResultStatus {
    return value as SubmissionResultStatus;
}

